// import MultipleValueTextInput from 'react-multivalue-text-input';
import {useEffect, useState} from "react";
import styled from "styled-components";
import {MAX_DOMAINS} from "../../../utils/const/threatGuardConsts";

const DomainsContainer = styled.div`

  .alert {
    position: absolute;
    margin-top: 5px;
  }
`;

const ThreatGuardDomains = (props) => {
    const {label, setThreatGuardFormData, fieldName} = props;
    const [domains, setDomains] = useState([]);
    const [validDomain, setValidDomain] = useState(true);
    const [domain, setDomain] = useState(null);

    const validate = (item) => {
        const regex = RegExp(/^((?!-))(xn--)?[a-zA-Z0-9][a-zA-Z0-9-_]{0,61}[a-zA-Z0-9]{0,1}\.(xn--)?([a-zA-Z0-9\-]{1,61}|[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}){2,5}$/);
        if (regex.test(item)) {
            return true;
        }
        return false;
    }

    const addItem = (item, allItems) => {
        if (allItems.length > MAX_DOMAINS) {
            allItems.length = MAX_DOMAINS;
            return;
        }
        else if (!validate(item)) {
            setValidDomain(false);
            setDomain(null);
            allItems.pop();
            return;
        }
        setDomain("");
        setValidDomain(true);
        setDomains(allItems)
    }

    const removeItem = (item, allItems) => {
        setDomains(allItems);
    }

    useEffect(() => {
        if (domains.length > 0) {
            setThreatGuardFormData(prevState => {
                return {
                    ...prevState,
                    [fieldName]: domains
                }
            })
            setDomain(null);
        }
    }, [domains])
    return (
        <>
            {fieldName === "domains" ?
                <label>{label}<span style={{color: "red"}}>*</span></label> :
                <label>{label}</label>
            }
            <DomainsContainer>
                {/*<MultipleValueTextInput*/}
                {/*    onItemAdded={addItem}*/}
                {/*    onItemDeleted={removeItem}*/}
                {/*    name={"customerDomains"}*/}
                {/*    placeholder={"Type domains (e.g. checkpoint.com, alarm.com)"}*/}
                {/*    className={"input-customer-domains"}*/}
                {/*    value={domain}*/}
                {/*/>*/}
                {(!validDomain && domains.length < MAX_DOMAINS) && <div className={"alert"}>Please provide valid domain</div>}
                {domains.length === MAX_DOMAINS && <div className={"alert"}>You have reached the maximum number of domains</div>}
            </DomainsContainer>
        </>
    );
}
export default ThreatGuardDomains;
